module.exports = __webpack_public_path__ + "img/part3-1.14064897.png";